const CONTEXT_ATTRIBUTE_KEYS = new Set([
  'status',
  'inbox_id',
  'team_id',
  'labels',
]);

export const getFilterValues = filter => {
  const raw = filter?.values;
  let values = [];
  if (Array.isArray(raw)) {
    values = raw;
  } else if (raw) {
    values = [raw];
  }

  return values
    .map(value => (value && typeof value === 'object' ? value.id : value))
    .filter(value => value !== undefined && value !== null && value !== '');
};

export const extractSingleStatus = payload => {
  if (!Array.isArray(payload)) return null;

  const statusFilters = payload.filter(
    filter => filter.attribute_key === 'status'
  );
  if (statusFilters.length !== 1) return null;
  if (statusFilters[0].filter_operator !== 'equal_to') return null;

  const values = getFilterValues(statusFilters[0]);
  if (values.length !== 1) return null;

  return String(values[0]);
};

const valuesMatchCurrent = (filter, currentValue) => {
  if (
    currentValue === undefined ||
    currentValue === null ||
    currentValue === ''
  ) {
    return false;
  }

  return getFilterValues(filter).map(String).includes(String(currentValue));
};

/**
 * Returns true when the applied filters only restate the current inbox/team/label
 * view plus a single status. Those should update the persisted status filter
 * instead of entering the temporary advanced-filter view.
 */
export const isContextOnlyConversationFilter = (
  payload,
  { inboxId, teamId, label } = {}
) => {
  if (!Array.isArray(payload) || payload.length === 0) return false;

  const counts = {};
  const isValidContextFilter = filter => {
    const key = filter.attribute_key;
    if (!CONTEXT_ATTRIBUTE_KEYS.has(key)) return false;
    if (filter.filter_operator !== 'equal_to') return false;

    counts[key] = (counts[key] || 0) + 1;
    return counts[key] === 1;
  };

  if (!payload.every(isValidContextFilter)) return false;

  if (counts.status && !extractSingleStatus(payload)) return false;

  if (inboxId) {
    const inboxFilter = payload.find(
      filter => filter.attribute_key === 'inbox_id'
    );
    if (!inboxFilter || !valuesMatchCurrent(inboxFilter, inboxId)) {
      return false;
    }
  } else if (counts.inbox_id) {
    return false;
  }

  if (teamId) {
    const teamFilter = payload.find(
      filter => filter.attribute_key === 'team_id'
    );
    if (!teamFilter || !valuesMatchCurrent(teamFilter, teamId)) {
      return false;
    }
  } else if (counts.team_id) {
    return false;
  }

  if (label) {
    const labelFilter = payload.find(
      filter => filter.attribute_key === 'labels'
    );
    if (!labelFilter || !valuesMatchCurrent(labelFilter, label)) {
      return false;
    }
  } else if (counts.labels) {
    return false;
  }

  return true;
};
